/**
 * Confirmation dialog for manual reconciliation
 */
function ConfirmationDialog({
  sourceRecord,
  targetRecord,
  reconcileChildren,
  loading,
  onConfirm,
  onCancel,
}) {
  return (
    <div className='bg-black/30 fixed inset-0 z-50 flex items-center justify-center'>
      <div className='bg-white w-full max-w-md rounded p-6 shadow-lg'>
        <h3 className='mb-4 text-lg font-bold'>Confirm Reconciliation</h3>

        <p className='mb-4'>
          Are you sure you want to reconcile these records? This action cannot be undone.
        </p>

        <div className='bg-gray-50 mb-4 rounded p-2 text-sm'>
          <p>
            <strong>Source:</strong> {sourceRecord?.title} ({sourceRecord?.service})
          </p>
          <p>
            <strong>Target:</strong> {targetRecord?.title} ({targetRecord?.service})
          </p>
          <p className='text-gray-600 mt-2'>
            Source record will be assigned to cloud ID {targetRecord?.cloudId}
          </p>
          {reconcileChildren &&
            (sourceRecord?.mediaType === 'album' || sourceRecord?.mediaType === 'playlist') && (
              <p className='text-gray-600'>
                All songs in this {sourceRecord?.mediaType} will also be reconciled
              </p>
            )}
        </div>

        <div className='flex justify-end gap-2'>
          <button onClick={onCancel} className='bg-gray-200 hover:bg-gray-300 rounded px-4 py-2'>
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className='bg-blue-500 text-white hover:bg-blue-600 rounded px-4 py-2'
            disabled={loading}
          >
            {loading ? 'Processing...' : 'Confirm Reconciliation'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationDialog
